import React, { useState } from "react";
import { toast } from "react-toastify";
import { submitEnquiry } from "../../services/api";
import "./ContactForm.css";

export default function ContactForm({
  compact = false,
  propertyName, // optional — only from property details / gate modal
  onSuccess,
  submitLabel,
}) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const validate = () => {
    const map = {};
    if (!form.name.trim()) map.name = "Name is required";
    if (!form.email.trim()) map.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email))
      map.email = "Enter a valid email";
    const phoneDigits = form.phone.replace(/\D/g, ""); // keep only numbers
    if (!form.phone.trim()) map.phone = "Phone is required";
    else if (phoneDigits.length !== 10)
      map.phone = "Enter a valid 10-digit mobile number";
    if (!form.message.trim()) map.message = "Message is required";
    return map;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const map = validate();
    if (Object.keys(map).length) {
      setErrors(map);
      return;
    }

    setErrors({});
    setSubmitting(true);
    setSuccess(false);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
      };

      // only attach property when parent passed propertyName
      if (propertyName) {
        payload.property = propertyName;
      }

      const res = await submitEnquiry(payload);

      toast.success(
        res.message || "Your enquiry has been submitted successfully."
      );
      setForm({ name: "", email: "", phone: "", message: "" });
      setSuccess(true);
      onSuccess?.(res.data || payload);
    } catch (err) {
      toast.error(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`contact-form ${compact ? "is-compact" : ""}`}
    >
      <Field
        label="Name"
        name="name"
        value={form.name}
        onChange={(v) => setForm({ ...form, name: v })}
        error={errors.name}
      />

      <Field
        label="Email"
        name="email"
        type="email"
        value={form.email}
        onChange={(v) => setForm({ ...form, email: v })}
        error={errors.email}
      />

      <Field
        label="Phone"
        name="phone"
        value={form.phone}
        onChange={(v) =>
          setForm({
            ...form,
            phone: v.replace(/\D/g, "").slice(0, 10),
          })
        }
        error={errors.phone}
      />
      <div className="cf-field">
        <label className="cf-label">Message</label>
        <textarea
          rows={compact ? 3 : 4}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="cf-input"
          placeholder={
            propertyName
              ? `I'd like to know more about ${propertyName}`
              : "How can we help?"
          }
        />
        {errors.message && <p className="cf-err">{errors.message}</p>}
      </div>

      <button type="submit" disabled={submitting} className="cf-submit">
        {submitting ? "Sending…" : submitLabel ?? "Request a Call Back"}
      </button>

      {success && (
        <p className="cf-success">
          Enquiry received — our advisor will reach out shortly.
        </p>
      )}
    </form>
  );
}

function Field({ label, name, value, onChange, type = "text", error }) {
  return (
    <div className="cf-field">
      <label className="cf-label">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="cf-input"
      />
      {error && <p className="cf-err">{error}</p>}
    </div>
  );
}